module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/medipremium-3.png?a9c7dc29";